/*
 *
 * Package: `@dbh/search-results-heading-theme`.
 *
 */const THEME_KEY_SEARCH_RESULTS_HEADER="SearchResultsHeader";const modifySearchResultsHeaderTheme=a=>{let{spacing:{sp11:b}}=a;return {[THEME_KEY_SEARCH_RESULTS_HEADER]:{columnWithMinHeight:{minHeight:b}}}};

export { THEME_KEY_SEARCH_RESULTS_HEADER, modifySearchResultsHeaderTheme as default };
